module.exports = __webpack_public_path__ + "static/media/automation-main-2.c641447a.png";